import axios from 'axios'
const baseUrl = '/api/players'

const getAll = async id => {
  const request = await axios.get(baseUrl + '/' + id)
  return request.data
}

const getMyPlayers = async id => {
  const reguest = await axios.get(baseUrl + '/my/' + id)
  return reguest.data
}

const getOnePlayer = async (id, userid) => {
  try {
    const reguest = await axios.get(baseUrl + '/one/' + id + '/' + userid)
    return reguest.data
  } catch (error) {
    return null
  }
}

const getCustomTemplate = async (playerId, oauthToken) => {
  const response = await axios.post(
    `${baseUrl}/custom/template/${playerId}`,
    {},
    {
      headers: {
        'x-oauth-token': oauthToken,
      },
    }
  )
  return response.data
}

const createCustom = async (customPlayer, oauthToken) => {
  const response = await axios.post(`${baseUrl}/custom/create`, customPlayer, {
    headers: {
      'x-oauth-token': oauthToken,
    },
  })
  return response.data
}

const deleteCustom = async (customPlayerId, oauthToken) => {
  await axios.delete(`${baseUrl}/custom/${customPlayerId}`, {
    headers: {
      'x-oauth-token': oauthToken,
    },
  })
}

const create = async newObject => {
  const response = await axios.post(baseUrl, newObject)
  return response.data
}

const remove = async player => {
  const response = await axios.delete(`${baseUrl}/${player.playerId}`)
  return response.data
}

export default {
  getAll,
  getMyPlayers,
  getOnePlayer,
  getCustomTemplate,
  createCustom,
  deleteCustom,
  create,
  remove,
}
